// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fontSize {
  font-size: 11pt;
}

.mat-button-toggle-group {
  align-items: center;
  font-size: 14px;
  font-weight: normal;
  height: 40px;
}

.mat-button-toggle-checked {
  background-color: #8de2cf;
}

:host ::ng-deep .mat-mdc-form-field-focus-overlay {
  background-color: transparent !important;
}
:host ::ng-deep .mat-mdc-form-field-focus-overlay :hover {
  background-color: transparent !important;
}

:host ::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) {
  background-color: transparent !important;
}
:host ::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) :hover {
  background-color: transparent !important;
}

.primary-btn {
  background-color: #00677F !important;
  color: white !important;
  cursor: pointer;
}

.export-btn {
  --mdc-protected-button-container-height: 38px;
  line-height: 40px;
  margin-top: 9px;
}

.disable-btn {
  background-color: #89b5c0 !important;
  color: white !important;
  cursor: not-allowed;
}

.warn-btn {
  background-color: #dd6b55;
  color: white;
  cursor: pointer;
}

.mapCenter {
  bottom: 115px;
  right: 12px !important;
  padding: 18px !important;
}

mat-drawer {
  background-color: #f8f9fa;
  width: 46%;
}

mat-drawer-container {
  height: 100vh;
}

.buttonMatDrawerToggle {
  position: absolute;
  top: 30px;
  left: -4px;
  border-radius: 4px;
  padding: 0;
  max-width: 30px;
  min-width: 30px;
  height: 50px;
  z-index: 4;
}

.drawer-container {
  overflow: auto;
}

/* TODO(mdc-migration): The following rule targets internal classes of button that may no longer apply for the MDC version. */
mat-button-toggle-group {
  background: white;
  margin-top: 10px;
}

/* TODO(mdc-migration): The following rule targets internal classes of button that may no longer apply for the MDC version. */
mat-button-toggle {
  color: black;
  padding: 1px;
}

/* TODO(mdc-migration): The following rule targets internal classes of button that may no longer apply for the MDC version. */
.mat-button-toggle-checked {
  font-weight: 500;
}

.table-container {
  overflow: auto;
}

table {
  width: 100%;
}

tr.example-element-row:hover:not(.data-selected) {
  background: whitesmoke;
}

.data-selected {
  background: #e5e6e8 !important;
}

.green-status {
  font-weight: 700;
  color: green;
}

.red-status {
  font-weight: 700;
  color: red;
}

.viewOptions {
  position: absolute !important;
  visibility: visible !important;
  padding-top: 8px;
  padding-bottom: 8px;
  margin-top: 10px;
  border: none;
  border-radius: 2px;
  box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px -1px;
}`, "",{"version":3,"sources":["webpack://./src/app/geofence/list-geofence/list-geofence.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;AACJ;;AAEA;EACI,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;EAII,wCAAA;AAFJ;AADI;EACE,wCAAA;AAGN;;AAEA;EAII,wCAAA;AAFJ;AADI;EACE,wCAAA;AAGN;;AAEA;EACI,oCAAA;EACA,uBAAA;EACA,eAAA;AACJ;;AAEA;EACI,6CAAA;EACA,iBAAA;EACA,eAAA;AACJ;;AAEA;EACI,oCAAA;EACA,uBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,yBAAA;EACA,YAAA;EACA,eAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,wBAAA;AACJ;;AAEA;EACI,yBAAA;EACA,UAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AAEA;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,UAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA,6HAAA;AACA;EACI,iBAAA;EACA,gBAAA;AACJ;;AAEA,6HAAA;AACA;EACI,YAAA;EACA,YAAA;AACJ;;AAEA,6HAAA;AACA;EACI,gBAAA;AACJ;;AAEA;EAEI,cAAA;AAAJ;;AAGA;EACI,WAAA;AAAJ;;AAGA;EACI,sBAAA;AAAJ;;AAEA;EACI,8BAAA;AACJ;;AAEA;EAEI,gBAAA;EACA,YAAA;AAAJ;;AAGA;EAEI,gBAAA;EACA,UAAA;AADJ;;AAIA;EACI,6BAAA;EACA,8BAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,+CAAA;AADJ","sourcesContent":[".fontSize {\n    font-size: 11pt;\n}\n\n.mat-button-toggle-group {\n    align-items: center;\n    font-size: 14px;\n    font-weight: normal;\n    height: 40px;\n    //margin-top: 15px;\n}\n.mat-button-toggle-checked {\n    background-color: #8de2cf;\n}\n\n:host ::ng-deep .mat-mdc-form-field-focus-overlay {\n    :hover {\n      background-color: transparent !important;\n    }\n    background-color: transparent !important;\n}\n  \n:host ::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) {\n    :hover {\n      background-color: transparent !important;\n    }\n    background-color: transparent !important;\n}\n\n.primary-btn {\n    background-color: #00677F !important;\n    color: white !important;\n    cursor: pointer;\n}\n\n.export-btn {\n    --mdc-protected-button-container-height: 38px;\n    line-height: 40px;\n    margin-top: 9px;\n}\n\n.disable-btn {\n    background-color: #89b5c0 !important;\n    color: white !important;\n    cursor: not-allowed;\n}\n\n.warn-btn {\n    background-color: #dd6b55;;\n    color: white;\n    cursor: pointer;\n}\n\n.mapCenter {\n    bottom: 115px;\n    right: 12px !important;\n    padding: 18px !important;\n}\n\nmat-drawer {\n    background-color: #f8f9fa;\n    width: 46%;\n}\n\nmat-drawer-container {\n    height: 100vh;\n}\n\n.buttonMatDrawerToggle{\n    position: absolute;\n    top: 30px;\n    left: -4px;\n    border-radius: 4px;    \n    padding: 0;\n    max-width: 30px;\n    min-width: 30px;\n    height: 50px;\n    z-index: 4;\n}\n\n.drawer-container {\n    overflow: auto;\n}\n\n/* TODO(mdc-migration): The following rule targets internal classes of button that may no longer apply for the MDC version. */\nmat-button-toggle-group {\n    background: white;\n    margin-top: 10px;\n}\n  \n/* TODO(mdc-migration): The following rule targets internal classes of button that may no longer apply for the MDC version. */\nmat-button-toggle {\n    color: black;\n    padding: 1px;\n}\n\n/* TODO(mdc-migration): The following rule targets internal classes of button that may no longer apply for the MDC version. */\n.mat-button-toggle-checked {\n    font-weight: 500;\n}\n\n.table-container {\n    //max-height: 460px;\n    overflow: auto;\n}\n\ntable {\n    width: 100%;\n}\n\ntr.example-element-row:hover:not(.data-selected) {\n    background: whitesmoke;\n}\n.data-selected {\n    background: #e5e6e8 !important;\n}\n\n.green-status {\n    //font-style: italic;\n    font-weight: 700;\n    color: green;\n}\n\n.red-status {\n    //font-style: italic;\n    font-weight: 700;\n    color: red;\n}\n\n.viewOptions {\n    position: absolute !important;\n    visibility: visible !important;\n    padding-top: 8px;\n    padding-bottom: 8px;\n    margin-top: 10px;\n    border: none;\n    border-radius: 2px;\n    box-shadow: rgb(0 0 0 / 30%) 0px 1px 4px -1px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
